import { combineReducers } from "redux"
import profile from "./profile"
import alerts from "./alerts"
import emissions from "./tabularData/emissions"
import marks from "./tabularData/marks"

export default combineReducers({ profile, alerts, emissions, marks })
